import { useAtom } from 'jotai'
import { atomWithStorage } from 'jotai/utils'
import dayjs from '~/utils/dayjs'
import {
  getLocalStorage,
  removeLocalStorage,
  setLocalStorage,
} from '~/utils/storage'

export function useDebugTimeOverride() {
  return useAtom(debugTimeOverrideEnabledStorageAtom)
}

export const debugTimeOverrideEnabledStorageAtom = atomWithStorage(
  'debug::time-override:enable',
  false,
)

export const debugTimeOverrideStorageAtom = atomWithStorage(
  'debug::time-override:time',
  dayjs.tz(
    getLocalStorage('debug::time-override:time') || dayjs().toISOString(),
  ),
  {
    getItem: (key, init) => {
      const value = getLocalStorage(key)
      return value ? dayjs(value) : init
    },
    setItem: (key, value) => setLocalStorage(key, value.toISOString()),
    removeItem: key => removeLocalStorage(key),
  },
)
